import { useReducer, useState } from "react";
import { useAppDispatch } from "../../../effects/useAppDispatch";
import { RequestState } from "../../../constants/request-state";
import { transactionNotesService } from "../../../services/transaction-notes.service";
import { errorActions } from "../../../actions";
import { notesRequestActions, NotesRequestReducer } from "../state/notes-request-state";

export function useTransactionNoteDelete() {
    const [requestState, dispatch] = useReducer(NotesRequestReducer, {})

    const noteDeleteCallback = async (noteId: number) => {
        dispatch(notesRequestActions.stateChanged(noteId, RequestState.request));
        try {
            await transactionNotesService.deleteNote(noteId);
            dispatch(notesRequestActions.stateChanged(noteId, RequestState.success));
            return true;
        } catch (e) {
            dispatch(notesRequestActions.stateChanged(noteId, RequestState.failure));
            return false;
        }
    }

    return { requestState, noteDeleteCallback };
}

export function useMyNotesDelete() {
    const dispatch = useAppDispatch();
    const [requestState, setRequestState] = useState(RequestState.none);

    const myNotesDeleteCallback = async (dealReferenceName: string, transactionReferenceName: string) => {
        setRequestState(RequestState.request);
        try {
            await transactionNotesService.ddeleteMyNotes(dealReferenceName, transactionReferenceName);
            setRequestState(RequestState.success);
            return true;
        } catch (e) {
            dispatch(errorActions.unexpectedError(e));
            setRequestState(RequestState.failure);
            return false;
        } finally {
            setRequestState(RequestState.none);
        }
    }

    return { requestState, myNotesDeleteCallback };
}